'use client';
import React, { ReactElement } from 'react';
import { Icon, IconButton, TextField } from 'ui-components';
import DayCalendarPopover from '../day-calendar-popover';
import { DatePickerProps } from './date-picker.props';
import useDatePicker from './date-picker.hook';

const DatePicker = (props: DatePickerProps): ReactElement => {
  const { id, name, placeholder, error, popoverElevation, shouldAllowClear } = props;
  const {
    date,
    typedDate,
    isTypedDateInvalid,
    calendarAnchorEl,
    handleTypedDateChange,
    handleTypedDateBlur,
    handleTypedDateKeyDown,
    handleOpenCalendar,
    handleCloseCalendar,
    handleSelectDay,
    handleClear,
  } = useDatePicker(props);

  return (
    <>
      <TextField
        id={id}
        name={name}
        data-testid={`${name}-date-picker`}
        value={typedDate}
        placeholder={placeholder}
        error={error || isTypedDateInvalid}
        onChange={handleTypedDateChange}
        onBlur={handleTypedDateBlur}
        onKeyDown={handleTypedDateKeyDown}
        autoComplete="off"
        inputProps={{ inputMode: 'numeric' }}
        endAdornment={
          <IconButton size="small" aria-label="Ouvrir le calendrier" onClick={handleOpenCalendar}>
            <Icon name="calendar" size="small" />
          </IconButton>
        }
      />
      <DayCalendarPopover
        anchorEl={calendarAnchorEl}
        date={date}
        onClose={handleCloseCalendar}
        onSelectDay={handleSelectDay}
        onClear={(shouldAllowClear && handleClear) || undefined}
        popoverElevation={popoverElevation}
      />
    </>
  );
};

export default DatePicker;
